import React, { Component } from 'react';
import CustomLineChart from '../../comonents/CustomLineChart';
import AppTableFilter from '../../../../../components/crud/table/AppTableFilter';
import Api from '../../../../../logic/api/Api';

class AndroidInstall extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    // Load data and initialize graph
    this._loadData();
  }

  _filter(filter) {
    this._loadData(filter);
  }

  async _loadData(filter = []) {
    try {
      const result = await Api.call('stats/stores/google/installs', { filter });
      this.setState({
        ...result.data
      });
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    return (
      <div className="row">
        <div className="main-inner col-10" style={{ paddingBottom: 0 }}>
          <CustomLineChart
            chartId="android-install"
            graph="install"
            data={this.state}
            label="android installations"
          />
        </div>
        <div
          className="col-2"
          style={{
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            padding: 5
          }}
        >
          <div style={{ flex: 1, flexGrow: 1 }}>
            <AppTableFilter
              columnForm
              onInit={comp => (this._tableFilter = comp)}
              format="DD/MM/YYYY"
              filter={[
                {
                  name: 'fromDate',
                  type: 'datetime',
                  field: 'created',
                  operation: 'gte',
                  label: 'From Date'
                },
                {
                  name: 'toDate',
                  type: 'datetime',
                  field: 'created',
                  operation: 'lte',
                  label: 'To Date'
                }
              ]}
              {...this.props}
              onFilter={filter => this._filter(filter)}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default AndroidInstall;
